import React, { useState } from 'react';
import {
  Rocket, Trophy, FileText, MessageCircle, ShieldCheck, Sparkles, Gift, Zap,
  Download, Flame, DollarSign, Target, Star, CheckCircle2, ArrowUpRight,
  Copy, Check, ChevronDown, Gem, Clock3, Radio, TrendingUp, Users, Swords,
  LayoutDashboard, GraduationCap, Smartphone, Link2,
} from 'lucide-react';

const JOIN_URL = 'https://app.kako.live/app/share.html?&id=10457657&lng=pt';
const DOWNLOAD_URL = 'https://www.kako.live/act/anchor_invite_anchor_share.html?refer=AI1007635845&invite_showid=10765749';
const WHATSAPP_URL = 'https://api.whatsapp.com/send/?phone=5528999565056&text=Ol%C3%A1!%20Quero%20fazer%20parte%20da%20Fox%20Agency%20na%20KAKO%20Live';
const AGENCY_ID = '10457657';

const IMG_HERO = 'https://images.unsplash.com/photo-1594009375825-564aac98bda6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTN8MHwxfHNlYXJjaHw0fHxmZW1hbGUlMjBsaXZlJTIwc3RyZWFtZXIlMjBnYW1pbmclMjBzZXR1cCUyMG1pY3JvcGhvbmV8ZW58MHx8fHwxNzg4NTc3NDMyfDA&ixlib=rb-4.1.0&q=85';
const IMG_STUDIO = 'https://images.unsplash.com/photo-1633933757597-2d09c360c2ad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHw0fHxsaXZlJTIwc3RyZWFtZXIlMjBicm9hZGNhc3QlMjBzdHVkaW8lMjBuZW9ufGVufDB8fHx8MTc4ODU3NzQzMnww&ixlib=rb-4.1.0&q=85';

const noop = () => {};

const GlowBtn = ({ href, children, testId, secondary, className = '' }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testId}
    className={`group inline-flex items-center justify-center gap-2 rounded-xl px-6 h-13 py-3.5 text-sm font-black uppercase tracking-wide transition-all duration-200 active:scale-[0.97] ${secondary
      ? 'border border-white/15 bg-white/[0.04] text-white hover:border-orange-500/50 hover:bg-white/[0.08]'
      : 'bg-gradient-to-b from-[#FF7A33] to-[#FF5E14] text-white shadow-[0_0_32px_rgba(255,94,20,0.45)] hover:shadow-[0_0_48px_rgba(255,94,20,0.65)] hover:-translate-y-0.5'} ${className}`}>
    {children}
  </a>
);

const Kicker = ({ children }) => (
  <p className="text-[11px] uppercase font-bold tracking-[0.25em] text-orange-400 mb-3 flex items-center gap-2">
    <span className="h-px w-6 bg-orange-500/70" /> {children}
  </p>
);

const TICKER = [
  '70% de comissão em presentes exclusivos', 'Pagamentos em dólar (USD)',
  'Saque liberado em até 24h', 'Bônus semanal Trabalhou Ganhou',
  'Star Host: até US$ 15 por dia', 'Suporte humano no WhatsApp',
  'Painel do host em tempo real', 'Salário de meta pago diariamente',
];

const STAR_TIERS = {
  A: { bonus: 5, hours: '3h de live por dia', keep: '1,2M cristais por ciclo', ring: 'ring-sky-400/50', text: 'text-sky-300', bar: 'from-sky-500 to-blue-600' },
  S: { bonus: 10, hours: '4h de live por dia', keep: '3M cristais por ciclo', ring: 'ring-violet-400/50', text: 'text-violet-300', bar: 'from-violet-500 to-purple-700' },
  SS: { bonus: 15, hours: '4h de live por dia', keep: '4,8M cristais por ciclo', ring: 'ring-amber-300/60', text: 'text-amber-300', bar: 'from-amber-400 to-orange-500' },
};

const FAQ = [
  ['Preciso pagar algo para entrar na Fox Agency?', 'Não. A entrada na agência é 100% gratuita. Você só precisa do app KAKO Live instalado e da certificação de host — a Fox te acompanha em todo o processo.'],
  ['Quanto ganha um host na KAKO Live?', 'Você recebe 70% de comissão nos presentes exclusivos, 5% nos presentes da sorte e um salário de meta pago diariamente (ex.: 1M em presentes da sorte + 2h de live = 72K cristais no dia). Star Hosts ainda ganham bônus diário de US$ 5 a US$ 15.'],
  ['Como funciona o saque?', 'Conversão fixa: 10.000 cristais = US$ 1. Saque mínimo de US$ 5, a qualquer momento, com o valor creditado em até 24 horas após a aprovação.'],
  ['Quantas horas preciso transmitir?', 'A meta diária é de no mínimo 2 horas de live (podem ser divididas ao longo do dia). Sem a meta de horas você não recebe o salário do dia, mas as comissões de presentes continuam caindo normalmente.'],
  ['Sou iniciante. Tenho algum apoio?', 'Sim! Novos hosts certificados têm 15 dias de apoio: nos primeiros 5 dias, transmitindo 2h/dia, você ganha US$ 2 por dia mesmo sem meta de presentes — além de bônus progressivos do 6º ao 15º dia.'],
  ['O que é o Trabalhou Ganhou?', 'É o evento interno exclusivo da Fox: toda semana, quem cumpre a meta de dias e horas de live ganha bônus extra em moedas, pago pela própria agência — por fora de tudo que você já recebe do app.'],
];

const CopyAgencyId = () => {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(AGENCY_ID); } catch { noop(); }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return (
    <button type="button" onClick={copy} data-testid="copy-agency-id-button"
      className="inline-flex items-center gap-2 rounded-lg border border-white/15 bg-white/[0.05] px-3 py-1.5 font-mono text-sm font-bold text-orange-300 transition-colors hover:border-orange-500/50">
      ID {AGENCY_ID}
      {copied ? <Check className="w-3.5 h-3.5 text-emerald-400" /> : <Copy className="w-3.5 h-3.5 text-neutral-400" />}
    </button>
  );
};

export default function FoxAgencyPage() {
  const [tier, setTier] = useState('SS');
  const [openFaq, setOpenFaq] = useState(0);
  const t = STAR_TIERS[tier];

  return (
    <div className="min-h-screen bg-[#07080B] text-white font-display antialiased selection:bg-orange-500/40 pb-24 md:pb-0">
      <style>{`
        @keyframes fox-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
        @keyframes fox-pulse { 0%,100% { opacity:.55 } 50% { opacity:1 } }
        @keyframes fox-rise { from { opacity:0; transform: translateY(14px);} to { opacity:1; transform: translateY(0);} }
        .fox-rise { animation: fox-rise .7s cubic-bezier(.2,.7,.3,1) both; }
      `}</style>

      {/* Glow ambiente */}
      <div aria-hidden className="pointer-events-none fixed inset-0 z-0">
        <div className="absolute -top-40 left-1/2 h-[480px] w-[720px] -translate-x-1/2 rounded-full bg-[#FF5E14] opacity-[0.09] blur-[140px]" />
        <div className="absolute bottom-0 right-0 h-[360px] w-[420px] rounded-full bg-[#FFB800] opacity-[0.05] blur-[120px]" />
      </div>

      {/* Navbar */}
      <header className="sticky top-0 z-40 border-b border-white/[0.06] bg-[#07080B]/80 backdrop-blur-2xl">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
          <div className="flex items-center gap-2.5" data-testid="foxagency-brand">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-gradient-to-b from-[#FF7A33] to-[#FF5E14] shadow-[0_0_20px_rgba(255,94,20,0.5)]">
              <Flame className="h-5 w-5 text-white" />
            </span>
            <div className="leading-none">
              <p className="font-black tracking-widest text-sm">FOX AGENCY</p>
              <p className="text-[10px] uppercase tracking-[0.2em] text-neutral-500">Kako Live · Brasil</p>
            </div>
          </div>
          <a href={JOIN_URL} target="_blank" rel="noopener noreferrer" data-testid="navbar-join-cta-button"
            className="hidden sm:inline-flex items-center gap-1.5 rounded-lg bg-gradient-to-b from-[#FF7A33] to-[#FF5E14] px-5 h-11 items-center text-xs font-black uppercase tracking-wider shadow-[0_0_24px_rgba(255,94,20,0.4)] transition-transform hover:-translate-y-0.5 active:scale-95">
            Entrar na agência <ArrowUpRight className="h-3.5 w-3.5" />
          </a>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="navbar-whatsapp-button"
            className="sm:hidden inline-flex items-center gap-1.5 rounded-lg border border-emerald-400/30 bg-emerald-400/10 px-3 py-2 text-xs font-bold text-emerald-300">
            <MessageCircle className="h-3.5 w-3.5" /> WhatsApp
          </a>
        </div>
      </header>

      {/* HERO */}
      <section className="relative z-10 mx-auto max-w-6xl px-4 sm:px-6 pt-12 sm:pt-20 pb-10 sm:pb-16">
        <div className="grid items-center gap-10 lg:grid-cols-[1.1fr_0.9fr]">
          <div className="fox-rise">
            <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-[0.18em] text-neutral-300">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-orange-500 opacity-60" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-orange-500" />
              </span>
              Agência oficial Kako Live · ID {AGENCY_ID}
            </div>
            <h1 data-testid="foxagency-hero-title"
              className="text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tighter leading-[1.02]">
              Sua live.<br />
              Sua renda.<br />
              <span className="bg-gradient-to-r from-[#FF7A33] via-[#FFB800] to-[#FF5E14] bg-clip-text text-transparent">Nossa estrutura.</span>
            </h1>
            <p className="mt-5 max-w-xl text-base sm:text-lg leading-relaxed text-neutral-400">
              A Fox Agency transforma streamers em profissionais na KAKO Live:
              <span className="text-white font-semibold"> 70% de comissão</span>, salário de meta diário,
              bônus Star Host em dólar e o evento <span className="text-white font-semibold">Trabalhou Ganhou</span> toda semana.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <GlowBtn href={JOIN_URL} testId="hero-join-button">
                <Rocket className="h-4 w-4" /> Entrar na agência
              </GlowBtn>
              <GlowBtn href={WHATSAPP_URL} testId="hero-whatsapp-button" secondary>
                <MessageCircle className="h-4 w-4 text-emerald-400" /> Falar com a Fox
              </GlowBtn>
            </div>
            <p className="mt-4 text-xs text-neutral-500 flex items-center gap-2 flex-wrap">
              <Smartphone className="h-3.5 w-3.5" /> Ainda não tem o app?
              <a href={DOWNLOAD_URL} target="_blank" rel="noopener noreferrer" data-testid="hero-download-app-link"
                className="font-bold text-orange-400 underline underline-offset-4 hover:text-orange-300">Baixe a KAKO Live aqui</a>
            </p>
          </div>

          {/* Visual HUD */}
          <div className="relative fox-rise" style={{ animationDelay: '.15s' }}>
            <div className="relative overflow-hidden rounded-3xl border border-white/10 shadow-[0_24px_80px_rgba(0,0,0,0.6)]">
              <img src={IMG_HERO} alt="Streamer profissional em live" className="h-[380px] sm:h-[440px] w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#07080B] via-[#07080B]/20 to-transparent" />
              <div className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-md bg-red-600 px-2.5 py-1 text-[11px] font-black uppercase tracking-wider shadow-lg">
                <Radio className="h-3 w-3" style={{ animation: 'fox-pulse 1.6s infinite' }} /> Ao vivo
              </div>
              <div className="absolute bottom-4 left-4 right-4 flex gap-3">
                <div className="flex-1 rounded-xl border border-white/10 bg-[#0F1117]/80 p-3 backdrop-blur-xl">
                  <p className="text-[10px] uppercase tracking-[0.18em] text-neutral-400">Comissão exclusivos</p>
                  <p className="text-xl font-black text-orange-400">70%</p>
                </div>
                <div className="flex-1 rounded-xl border border-white/10 bg-[#0F1117]/80 p-3 backdrop-blur-xl">
                  <p className="text-[10px] uppercase tracking-[0.18em] text-neutral-400">Star Host SS</p>
                  <p className="text-xl font-black text-amber-300">US$ 15<span className="text-xs text-neutral-400">/dia</span></p>
                </div>
                <div className="hidden sm:block flex-1 rounded-xl border border-white/10 bg-[#0F1117]/80 p-3 backdrop-blur-xl">
                  <p className="text-[10px] uppercase tracking-[0.18em] text-neutral-400">Saque</p>
                  <p className="text-xl font-black text-emerald-400">24h</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ticker */}
      <div className="relative z-10 border-y border-white/[0.06] bg-[#0F1117]/60 py-3 overflow-hidden" data-testid="foxagency-ticker">
        <div className="flex w-max gap-8 whitespace-nowrap" style={{ animation: 'fox-marquee 30s linear infinite' }}>
          {[...TICKER, ...TICKER].map((item, i) => (
            <span key={i} className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.15em] text-neutral-400">
              <Sparkles className="h-3.5 w-3.5 text-orange-500" /> {item}
            </span>
          ))}
        </div>
      </div>

      {/* Vantagens KAKO — bento */}
      <section className="relative z-10 mx-auto max-w-6xl px-4 sm:px-6 py-16 sm:py-24">
        <Kicker>O aplicativo</Kicker>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight max-w-2xl">
          A KAKO Live paga de verdade quem transmite de verdade
        </h2>
        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {[
            [DollarSign, '70% de comissão', 'A maior fatia é sua: presentes exclusivos rendem 70% e presentes da sorte 5%, creditados na hora.', 'lg:col-span-2', true],
            [Target, 'Salário de meta diário', 'Bateu a meta de presentes do dia com 2h de live? Salário + comissão caem no dia seguinte.', '', false],
            [Swords, 'Batalhas PK', 'Duelos ao vivo com alta arrecadação e público engajado torcendo por você.', '', false],
            [Clock3, 'Saque em até 24h', 'A partir de US$ 5, a qualquer momento. 10.000 cristais = US$ 1.', '', false],
            [Gem, 'Renda em dólar', 'Seus cristais valem dólar: proteção natural contra a desvalorização do real.', '', false],
            [TrendingUp, 'Eventos oficiais', 'Campanhas e rankings do próprio app com prêmios extras todo mês.', 'lg:col-span-2', false],
          ].map(([Icon, title, desc, span, featured]) => (
            <div key={title}
              className={`group rounded-2xl border p-6 transition-all duration-200 hover:-translate-y-1 ${span} ${featured
                ? 'border-orange-500/30 bg-gradient-to-br from-[#1a0f08] to-[#0F1117] shadow-[inset_0_1px_0_rgba(255,255,255,0.05),0_0_40px_rgba(255,94,20,0.12)]'
                : 'border-white/[0.07] bg-[#0F1117] hover:border-white/[0.16]'}`}>
              <span className={`inline-flex h-11 w-11 items-center justify-center rounded-xl border ${featured ? 'border-orange-500/40 bg-orange-500/15 text-orange-400' : 'border-white/10 bg-white/[0.04] text-neutral-300 group-hover:text-orange-400'} transition-colors`}>
                <Icon className="h-5 w-5" />
              </span>
              <p className="mt-4 font-black text-lg">{title}</p>
              <p className="mt-1.5 text-sm leading-relaxed text-neutral-400">{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Diferenciais Fox */}
      <section className="relative z-10 mx-auto max-w-6xl px-4 sm:px-6 py-16 sm:py-24">
        <div className="grid gap-10 lg:grid-cols-[0.9fr_1.1fr] items-center">
          <div className="relative order-2 lg:order-1">
            <div className="overflow-hidden rounded-3xl border border-white/10">
              <img src={IMG_STUDIO} alt="Estúdio de transmissão profissional" className="h-[300px] sm:h-[380px] w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#07080B] via-transparent to-transparent" />
            </div>
            <div className="absolute -bottom-4 left-4 right-4 sm:left-8 sm:right-8 rounded-2xl border border-orange-500/25 bg-[#0F1117]/95 p-4 backdrop-blur-xl shadow-[0_16px_48px_rgba(0,0,0,0.5)]">
              <p className="text-[10px] uppercase tracking-[0.2em] text-neutral-500">Exclusivo da família Fox</p>
              <p className="font-black text-orange-400 flex items-center gap-2 mt-0.5"><Trophy className="h-4 w-4" /> Trabalhou Ganhou · bônus toda semana</p>
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <Kicker>A agência</Kicker>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight">
              Não seja apenas mais um host solto no app
            </h2>
            <div className="mt-8 space-y-5">
              {[
                [Trophy, 'Trabalhou Ganhou toda semana', 'Cumpriu a meta de dias e horas de live na semana, ganhou bônus extra em moedas — pago pela própria Fox, por fora do app.'],
                [LayoutDashboard, 'Painel do host em tempo real', 'Acompanhe diamantes, horas válidas, metas Star Host e avisos oficiais no nosso painel online exclusivo.'],
                [GraduationCap, 'Mentoria e estratégia', 'Orientação de metas, engajamento e táticas de PK com quem entende do algoritmo da KAKO.'],
                [ShieldCheck, 'Candidatura Star Host', 'Somente agências indicam hosts ao programa Star Host — e a Fox faz isso por você, com avaliações de segunda a sexta.'],
              ].map(([Icon, title, desc]) => (
                <div key={title} className="flex gap-4">
                  <span className="mt-0.5 flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl border border-orange-500/25 bg-orange-500/10 text-orange-400">
                    <Icon className="h-5 w-5" />
                  </span>
                  <div>
                    <p className="font-black">{title}</p>
                    <p className="mt-1 text-sm leading-relaxed text-neutral-400">{desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Star Host interativo */}
      <section className="relative z-10 mx-auto max-w-6xl px-4 sm:px-6 py-16 sm:py-24">
        <Kicker>Programa Star Host</Kicker>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight max-w-2xl">
          Bônus em dólar, <span className="text-amber-300">todos os dias</span>
        </h2>
        <p className="mt-3 max-w-2xl text-sm sm:text-base text-neutral-400 leading-relaxed">
          Hosts com boa imagem, talento e dedicação são indicados pela Fox ao programa Star Host da KAKO — e recebem bônus diário além de todas as comissões.
        </p>

        <div className="mt-8 grid gap-6 lg:grid-cols-[0.55fr_1fr]">
          <div className="flex lg:flex-col gap-3">
            {Object.keys(STAR_TIERS).map((k) => (
              <button key={k} type="button" onClick={() => setTier(k)} data-testid={`star-tier-${k}`}
                className={`flex-1 rounded-2xl border p-4 sm:p-5 text-left transition-all duration-200 ${tier === k
                  ? `border-transparent bg-[#151822] ring-2 ${STAR_TIERS[k].ring} shadow-[0_0_32px_rgba(255,184,0,0.08)]`
                  : 'border-white/[0.07] bg-[#0F1117] hover:border-white/[0.18]'}`}>
                <p className={`font-black text-2xl ${STAR_TIERS[k].text}`}>{k}</p>
                <p className="text-[11px] uppercase tracking-[0.15em] text-neutral-500 mt-1">US$ {STAR_TIERS[k].bonus}/dia</p>
              </button>
            ))}
          </div>
          <div className="rounded-3xl border border-white/[0.08] bg-[#0F1117] p-6 sm:p-8" data-testid="star-tier-details">
            <div className="flex items-center justify-between flex-wrap gap-3">
              <p className="font-black text-xl flex items-center gap-2">
                <Star className={`h-5 w-5 ${t.text}`} /> Nível {tier}
              </p>
              <span className="rounded-full border border-white/10 bg-white/[0.04] px-3 py-1 text-[11px] font-bold uppercase tracking-[0.15em] text-neutral-400">
                + 8% da recarga de convidados
              </span>
            </div>
            <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-4">
              <div className="rounded-xl border border-white/[0.07] bg-[#07080B] p-4">
                <p className="text-[10px] uppercase tracking-[0.18em] text-neutral-500">Bônus diário</p>
                <p className={`mt-1 text-2xl sm:text-3xl font-black ${t.text}`} data-testid="star-tier-daily">US$ {t.bonus}</p>
              </div>
              <div className="rounded-xl border border-white/[0.07] bg-[#07080B] p-4">
                <p className="text-[10px] uppercase tracking-[0.18em] text-neutral-500">Em 30 dias</p>
                <p className="mt-1 text-2xl sm:text-3xl font-black text-white" data-testid="star-tier-monthly">US$ {t.bonus * 30}</p>
              </div>
              <div className="col-span-2 sm:col-span-1 rounded-xl border border-white/[0.07] bg-[#07080B] p-4">
                <p className="text-[10px] uppercase tracking-[0.18em] text-neutral-500">Só de bônus</p>
                <p className="mt-1 text-sm text-neutral-400 leading-snug">por fora de comissões e salário de meta</p>
              </div>
            </div>
            <div className="mt-5 h-1.5 w-full overflow-hidden rounded-full bg-white/[0.06]">
              <div className={`h-full rounded-full bg-gradient-to-r ${t.bar}`} style={{ width: `${(t.bonus / 15) * 100}%`, transition: 'width .4s cubic-bezier(.2,.7,.3,1)' }} />
            </div>
            <div className="mt-5 grid sm:grid-cols-2 gap-3 text-sm text-neutral-300">
              <p className="flex items-center gap-2"><Clock3 className="h-4 w-4 text-neutral-500" /> {t.hours}</p>
              <p className="flex items-center gap-2"><Gem className="h-4 w-4 text-neutral-500" /> Manter {t.keep}</p>
            </div>
            <p className="mt-5 text-xs text-neutral-500 leading-relaxed">
              Host novo pode ser indicado direto pela Fox. Host antigo precisa de presentes da sorte ≥ 100 milhões nos últimos 30 dias.
              Somente lives de vídeo contam. Bônus distribuído em cristais no dia seguinte (10.000 cristais = US$ 1).
            </p>
          </div>
        </div>
      </section>

      {/* Trabalhou Ganhou */}
      <section className="relative z-10 mx-auto max-w-6xl px-4 sm:px-6 py-16 sm:py-24">
        <div className="relative overflow-hidden rounded-3xl border border-orange-500/25 bg-gradient-to-br from-[#1a0f08] via-[#0F1117] to-[#0F1117] p-8 sm:p-12">
          <div aria-hidden className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#FF5E14] opacity-[0.12] blur-[90px]" />
          <Kicker>Evento interno exclusivo</Kicker>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight">
            Trabalhou Ganhou<span className="text-orange-400">.</span> Toda semana<span className="text-orange-400">.</span>
          </h2>
          <div className="mt-8 grid gap-4 sm:grid-cols-3">
            {[
              [Trophy, 'Ciclos semanais', 'Uma nova rodada toda semana: cumpra a meta de dias e horas de live e garanta o bônus.'],
              [Gift, 'Pago pela Fox', 'Recompensa extra em moedas, por fora de tudo que você já ganha dentro do app.'],
              [Flame, 'Rankings internos', 'Ranking de Estrelas e campanhas com premiações para os hosts mais dedicados.'],
            ].map(([Icon, title, desc]) => (
              <div key={title} className="rounded-2xl border border-white/[0.08] bg-[#07080B]/60 p-5 backdrop-blur">
                <Icon className="h-5 w-5 text-amber-300" />
                <p className="mt-3 font-black">{title}</p>
                <p className="mt-1 text-sm text-neutral-400 leading-relaxed">{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Políticas PDF */}
      <section className="relative z-10 mx-auto max-w-6xl px-4 sm:px-6 py-16 sm:py-24">
        <Kicker>Transparência total</Kicker>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight">Políticas oficiais, sem letra miúda</h2>
        <p className="mt-3 max-w-2xl text-sm sm:text-base text-neutral-400">Baixe os documentos completos e confira cada regra antes de entrar.</p>
        <div className="mt-8 grid gap-4 sm:grid-cols-3">
          {[
            ['pagamentos', 'Política de Hosts · Pagamentos', 'Tabela completa de salário de meta, comissões e regras de saque.', '/host-docs/politica-de-hosts.pdf'],
            ['star', 'Política de Star Host', 'Níveis A/S/SS, bônus diários, manutenção, promoção e obrigações.', '/host-docs/politica-star-host.pdf'],
            ['novos', 'Apoio a Novos Hosts', 'Bônus dos primeiros 15 dias para hosts certificados iniciantes.', '/host-docs/politica-integracao-novos-hosts.pdf'],
          ].map(([id, title, desc, file]) => (
            <a key={id} href={file} target="_blank" rel="noopener noreferrer" data-testid={`foxagency-policy-${id}`}
              className="group rounded-2xl border border-white/[0.07] bg-[#0F1117] p-6 transition-all duration-200 hover:-translate-y-1 hover:border-orange-500/40">
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-white/10 bg-white/[0.04] text-neutral-300 group-hover:text-orange-400 transition-colors">
                  <FileText className="h-5 w-5" />
                </span>
                <span className="text-[10px] font-black uppercase tracking-[0.2em] text-neutral-600 group-hover:text-orange-500 transition-colors">PDF</span>
              </div>
              <p className="mt-4 font-black leading-snug">{title}</p>
              <p className="mt-1.5 text-sm text-neutral-400 leading-relaxed">{desc}</p>
              <span className="mt-4 inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-orange-400">
                <Download className="h-3.5 w-3.5" /> Baixar documento
              </span>
            </a>
          ))}
        </div>
      </section>

      {/* 3 passos */}
      <section className="relative z-10 mx-auto max-w-6xl px-4 sm:px-6 py-16 sm:py-24">
        <Kicker>Comece hoje</Kicker>
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight">Entre na Fox em 3 passos</h2>
        <div className="mt-8 grid gap-4 lg:grid-cols-3">
          {[
            ['01', Smartphone, 'Baixe a KAKO Live', <>Instale o app e crie sua conta. <a href={DOWNLOAD_URL} target="_blank" rel="noopener noreferrer" data-testid="step-download-link" className="font-bold text-orange-400 underline underline-offset-4">Baixar agora</a>.</>],
            ['02', Link2, 'Entre pelo link ou ID', <>Use o <a href={JOIN_URL} target="_blank" rel="noopener noreferrer" data-testid="step-join-link" className="font-bold text-orange-400 underline underline-offset-4">link de convite da agência</a> ou informe nosso ID no app: <CopyAgencyId /></>],
            ['03', MessageCircle, 'Fale com a equipe', <>Chame no <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="step-whatsapp-link" className="font-bold text-emerald-400 underline underline-offset-4">WhatsApp da Fox</a> para certificação e boas-vindas.</>],
          ].map(([num, Icon, title, desc]) => (
            <div key={num} className="relative rounded-2xl border border-white/[0.07] bg-[#0F1117] p-6 pt-8">
              <span className="absolute -top-3.5 left-6 rounded-md bg-gradient-to-b from-[#FF7A33] to-[#FF5E14] px-2.5 py-1 font-mono text-xs font-black shadow-[0_0_16px_rgba(255,94,20,0.5)]">{num}</span>
              <Icon className="h-5 w-5 text-orange-400" />
              <p className="mt-3 font-black text-lg">{title}</p>
              <p className="mt-2 text-sm text-neutral-400 leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* FAQ */}
      <section className="relative z-10 mx-auto max-w-3xl px-4 sm:px-6 py-16 sm:py-24">
        <Kicker>Dúvidas frequentes</Kicker>
        <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight">O que todo futuro host pergunta</h2>
        <div className="mt-8 space-y-3">
          {FAQ.map(([q, a], i) => (
            <div key={q} className={`rounded-2xl border transition-colors ${openFaq === i ? 'border-orange-500/30 bg-[#0F1117]' : 'border-white/[0.07] bg-[#0F1117]/60'}`}>
              <button type="button" onClick={() => setOpenFaq(openFaq === i ? -1 : i)}
                data-testid={`faq-question-${i}`}
                className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left font-bold text-sm sm:text-base">
                {q}
                <ChevronDown className={`h-4 w-4 flex-shrink-0 text-neutral-500 transition-transform duration-200 ${openFaq === i ? 'rotate-180 text-orange-400' : ''}`} />
              </button>
              {openFaq === i && (
                <p className="px-5 pb-5 text-sm leading-relaxed text-neutral-400" data-testid={`faq-answer-${i}`}>{a}</p>
              )}
            </div>
          ))}
        </div>
      </section>

      {/* CTA final */}
      <section className="relative z-10 mx-auto max-w-6xl px-4 sm:px-6 pb-16 sm:pb-24">
        <div className="relative overflow-hidden rounded-3xl border border-orange-500/30 bg-gradient-to-br from-[#241105] via-[#12090b] to-[#0F1117] px-6 sm:px-14 py-12 sm:py-16 text-center">
          <div aria-hidden className="pointer-events-none absolute left-1/2 top-0 h-64 w-[520px] -translate-x-1/2 rounded-full bg-[#FF5E14] opacity-[0.16] blur-[100px]" />
          <p className="text-[11px] uppercase font-bold tracking-[0.25em] text-orange-400">Vagas abertas para novos talentos</p>
          <h2 className="mt-3 text-3xl sm:text-5xl font-black uppercase tracking-tighter leading-[1.05]">
            Pronto para viver<br />de live?
          </h2>
          <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
            <GlowBtn href={JOIN_URL} testId="footer-join-button">
              <Rocket className="h-4 w-4" /> Entrar na Fox Agency
            </GlowBtn>
            <GlowBtn href={WHATSAPP_URL} testId="footer-whatsapp-button" secondary>
              <MessageCircle className="h-4 w-4 text-emerald-400" /> WhatsApp da agência
            </GlowBtn>
          </div>
          <p className="mt-6 text-xs text-neutral-500 flex items-center justify-center gap-2 flex-wrap">
            <CheckCircle2 className="h-3.5 w-3.5 text-emerald-400" /> Entrada gratuita
            <CheckCircle2 className="h-3.5 w-3.5 text-emerald-400 ml-3" /> Suporte em português
            <CheckCircle2 className="h-3.5 w-3.5 text-emerald-400 ml-3" /> Pagamentos em dólar
          </p>
        </div>
        <footer className="mt-12 flex flex-col items-center gap-3 text-center">
          <div className="flex items-center gap-2">
            <span className="flex h-7 w-7 items-center justify-center rounded-md bg-gradient-to-b from-[#FF7A33] to-[#FF5E14]">
              <Flame className="h-4 w-4 text-white" />
            </span>
            <p className="font-black tracking-widest text-sm">FOX AGENCY</p>
          </div>
          <p className="text-xs text-neutral-500">
            <a href={JOIN_URL} target="_blank" rel="noopener noreferrer" className="text-orange-400/90 hover:text-orange-300 underline underline-offset-4">Entrar na agência</a>
            <span className="mx-2 text-neutral-700">·</span>
            <a href={DOWNLOAD_URL} target="_blank" rel="noopener noreferrer" className="text-orange-400/90 hover:text-orange-300 underline underline-offset-4">Baixar o app</a>
            <span className="mx-2 text-neutral-700">·</span>
            <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" className="text-orange-400/90 hover:text-orange-300 underline underline-offset-4">WhatsApp</a>
            <span className="mx-2 text-neutral-700">·</span>
            <a href="/" className="text-orange-400/90 hover:text-orange-300 underline underline-offset-4">Loja MoedasOnline</a>
          </p>
          <p className="max-w-lg text-[10px] leading-relaxed text-neutral-600">
            Valores em US$ conforme as políticas oficiais da KAKO Live (10.000 cristais = US$ 1), sujeitos às regras completas disponíveis nos documentos desta página.
          </p>
        </footer>
      </section>

      {/* Barra fixa mobile */}
      <div className="fixed inset-x-0 bottom-0 z-50 border-t border-white/[0.08] bg-[#07080B]/85 p-3 backdrop-blur-2xl md:hidden" data-testid="mobile-sticky-bar">
        <div className="flex gap-2">
          <a href={JOIN_URL} target="_blank" rel="noopener noreferrer" data-testid="mobile-join-button"
            className="flex flex-1 items-center justify-center gap-1.5 rounded-xl bg-gradient-to-b from-[#FF7A33] to-[#FF5E14] py-3.5 text-xs font-black uppercase tracking-wider shadow-[0_0_24px_rgba(255,94,20,0.4)] active:scale-[0.97] transition-transform">
            <Rocket className="h-4 w-4" /> Entrar na agência
          </a>
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" data-testid="mobile-whatsapp-button"
            className="flex items-center justify-center rounded-xl border border-emerald-400/30 bg-emerald-400/10 px-4 text-emerald-300 active:scale-[0.97] transition-transform">
            <MessageCircle className="h-5 w-5" />
          </a>
        </div>
      </div>
    </div>
  );
}
